export interface SmartBetsCreateState {
    smartBetsCreateData: any;
    loading: boolean;
    error: null | string;
}


export enum SmartBetsCreateActionTypes {
    FETCH_SMART_BETS_CRATE_DATA = "FETCH_SMART_BETS_CRATE_DATA",
    FETCH_SMART_BETS_CRATE_DATA_SUCCESS = "FETCH_SMART_BETS_CRATE_DATA_SUCCESS",
    FETCH_SMART_BETS_CRATE_DATA_ERROR = "FETCH_SMART_BETS_CRATE_DATA_ERROR",
}

export type SmartBetsCreateAction =
    | { type: SmartBetsCreateActionTypes.FETCH_SMART_BETS_CRATE_DATA }
    | { type: SmartBetsCreateActionTypes.FETCH_SMART_BETS_CRATE_DATA_SUCCESS; payload: any[] }
    | { type: SmartBetsCreateActionTypes.FETCH_SMART_BETS_CRATE_DATA_ERROR; payload: string };